import type { JSX } from "react";
import { useI18n } from "../shared/i18n/I18nContext";
import styles from "../shared/ui/ui.module.css";
import { useAppUpdate } from "./AppUpdateContext";

/**
 * Hint about a new application version (spec 11.4). The version is activated only on request;
 * while a synchronization runs, activation waits for it to finish.
 *
 * @returns The banner, or `null` if no update is available.
 */
export function UpdateBanner(): JSX.Element | null {
  const { t } = useI18n();
  const { state, activate } = useAppUpdate();

  if (state === "none") {
    return null;
  }

  const banner = (
    <div className={styles["row"]} role="status" aria-live="polite">
      {state === "available" ? (
        <>
          <span>{t("update.available")}</span>
          <button type="button" className={styles["button"]} onClick={activate}>
            {t("update.activate")}
          </button>
        </>
      ) : (
        <span>
          {state === "waitingForSync" ? t("update.waitingForSync") : t("update.activating")}
        </span>
      )}
    </div>
  );

  return banner;
}
